import JLPButtons from './JLPButtons'
import JLPDwellTimeSku from './JLPDwellTimeSku'
import JLPSessionsSku from './JLPSessionsSku'

const JLPReducers = [
  JLPButtons,
  JLPDwellTimeSku,
  JLPSessionsSku,
]

export default JLPReducers
